import queries from '@apis/queries';
import MyShopApi from '@apis/shop/MyShopApi';
import useToast from '@hooks/ui/useToast';
import { ErrorResponse } from '@models/error';
import { ShopInMapRow } from '@models/shop';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import { useState, MouseEvent, useEffect } from 'react';

function useShopFavorite(shop: ShopInMapRow) {
  const [isMyShop, setIsMyShop] = useState(shop.isMyShop);
  const toast = useToast();
  const queryClient = useQueryClient();
  const [isLoading, setIsLoading] = useState(false);
  const { mutate } = useMutation({
    mutationFn: MyShopApi.toggleMyShop,
    onMutate() {
      setIsLoading(true);
    },
    onSuccess() {
      queryClient.invalidateQueries({
        queryKey: queries.shop._def,
      });
      if (isMyShop) {
        toast.success('MY 매장에서 제거되었습니다.');
      } else {
        toast.success('MY 매장이 추가되었습니다.');
      }
      setIsMyShop(!isMyShop);
    },
    onError(e: AxiosError<ErrorResponse>) {
      console.error(e);
      toast.error(e?.response?.data.message || '오류가 발생하였습니다.');
    },
    onSettled() {
      setIsLoading(false);
    },
  });
  const toggleMyShop = (e: MouseEvent<HTMLDivElement>) => {
    e.preventDefault();
    e.stopPropagation();
    if (!isLoading) {
      mutate(shop.id);
    }
  };
  useEffect(() => {
    setIsMyShop(shop.isMyShop);
  }, [shop]);
  return {
    isMyShop, toggleMyShop,
  };
}

export default useShopFavorite;
